import * as React from "react";
function SupportIcon({ title, titleId, className, ...props }, svgRef) {
	return (
		<svg
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			xmlns:svg="http://www.w3.org/2000/svg">
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="m 9.879,7.519 c 1.171,-1.025 3.071,-1.025 4.242,0 1.172,1.025 1.172,2.687 0,3.712 -0.203,0.179 -0.43,0.326 -0.67,0.442 -0.745,0.361 -1.45,0.999 -1.45,1.827 v 0.75 m -10e-4,3 h 0.008 v 0.008 H 12 Z"
			/>
		</svg>
	);
}
const ForwardRef = React.forwardRef(SupportIcon);
export default ForwardRef;
